import { userHasFreeTier } from '@wetransfer/transfer/helper/user';
import Router from '@wetransfer/transfer/modules/router';
import Store from '@wetransfer/transfer/store';

export const init = () => {
  const { user, account } = Store.getState();

  if (!account.active_subscription) {
    return;
  }

  if (!user.preferences.onboarded && user.loggedIn && user.isVerified) {
    if (userHasFreeTier(user)) {
      Router.navigateTo('/sign-up/completed');
    } else {
      Router.navigateTo('/payment/completed');
    }
  }
};
